import {
    WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_ERROR,
    WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_REQUEST,
    WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_SUCCESS,
    WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_CLEAR,
} from '../../Types/user/Types';

const initialState = {
    error: '',
    workspace_supportingDocument_data: '',
    loader: false,
};
const workspaces_Supporting_Document_FolderCreate_Reducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_SUCCESS:
            return {
                ...initialState.workspace_supportingDocument_data,
                error: '',
                workspace_supportingDocument_data: action.payload,
                loader: false,
            };
        case WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_ERROR:
            return {
                ...initialState.workspace_supportingDocument_data,
                error: action.error,
                workspace_supportingDocument_data: '',
                loader: false,
            };
        case WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_REQUEST:
            return {
                ...initialState.workspace_supportingDocument_data,
                error: null,
                workspace_supportingDocument_data: '',
                loader: true,
            };
        case WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_CLEAR:
            return {
                ...initialState.workspace_supportingDocument_data,
                error: null,
                workspace_supportingDocument_data: '',
                loader: false,
            };
        default:
            return state;
    }
};

export default workspaces_Supporting_Document_FolderCreate_Reducer;
